export const submitInquiryForm = async (formValues, dispatch, props) => {
  const {
    sendInquiryRequest
  } = props;
  sendInquiryRequest();
};
